import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "../Styles/DeleteBlog.css";
import LayOut from "../../components/LayOut";
import { toast } from "react-hot-toast";

const DeleteBlog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch blogs from the backend
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get("/api/v1/blog/blogs");
        if (response.data.success) {
          setBlogs(response.data.blogs);
        } else {
          toast.error("Error fetching blogs");
        }
      } catch (error) {
        console.error("Error fetching blogs:", error.message);
        toast.error("Error fetching blogs");
      }
    };

    fetchBlogs();
  }, []);

  // Helper function to convert blog photo data to base64
  const getImageSrc = useCallback((photo) => {
    if (!photo || !photo.data) {
      return "https://via.placeholder.com/150";
    }

    try {
      if (Array.isArray(photo.data.data)) {
        const base64String = btoa(
          String.fromCharCode(...new Uint8Array(photo.data.data))
        );
        return `data:${photo.contentType};base64,${base64String}`;
      }
    } catch (error) {
      console.error("Error converting image:", error.message);
    }

    return "https://via.placeholder.com/150";
  }, []);

  // Handle delete blog
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    setLoading(true);
    try {
      const response = await axios.delete(
        `https://portfoliomern-mxue.onrender.com/api/v1/blog/delete-blog/${id}`
      );
      if (response.data.success) {
        setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog._id !== id));
        toast.success("Blog deleted successfully");
      } else {
        toast.error("Error deleting blog");
      }
    } catch (error) {
      console.error("Error deleting blog:", error.message);
      toast.error("Error deleting blog");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayOut title={"Delete Blog"}>
      <div
        className="delete-blog-page container"
        style={{ backgroundColor: "#101010", minHeight: "100vh" }}
      >
        <h2 className="text-center text-white py-4">Delete Blogs</h2>
        {blogs.length === 0 ? (
          <p className="text-center text-white">No blogs available</p>
        ) : (
          <div className="row">
            {blogs.map((blog) => (
              <div key={blog._id} className="col-md-4 col-sm-6 my-3">
                <div className="card blog-card bg-dark text-white">
                  <img
                    src={getImageSrc(blog.photo)}
                    alt={blog.name || "Blog"}
                    className="card-img-top"
                  />
                  <div className="card-body">
                    <h5 className="card-title">
                      {blog.name || "Untitled Blog"}
                    </h5>
                    <p className="card-text">
                      {blog.description
                        ? blog.description.substring(0, 100)
                        : "No description available"}
                    </p>
                    <button
                      className="btn btn-danger w-100"
                      onClick={() => handleDelete(blog._id)}
                      disabled={loading}
                    >
                      {loading ? "Deleting..." : "Delete"}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </LayOut>
  );
};

export default DeleteBlog;
